import { useState } from 'react';
// i18n
import { useTranslation } from 'react-i18next';
// Context
import { useTips } from 'app/context/Tips.context';
// Store
import { useAppSelector } from 'app/hooks/useStore';
import { selectHasAnyActiveSubscriptionPackageRecurring } from 'app/store/BillingSubscriptions/BillingSubscriptions.selectors';
// Mui
import { Box, Tooltip } from '@mui/material';
// Icons
import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material';
// Components
import { Button, IconButton } from 'app/components/Mui';
import RequestInterimInvoiceDialog from './RequestInterimInvoiceDialog';

export default function RequestInterimInvoiceButton({ predefinedCase }:{ predefinedCase?:any }) {
  const { t } = useTranslation();
  const { showTip } = useTips();

  const hasAnyActiveSubscriptionPackageRecurring = useAppSelector(selectHasAnyActiveSubscriptionPackageRecurring);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  if ( !hasAnyActiveSubscriptionPackageRecurring ) return null;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Button
        name="Request interim invoice"
        onClick={handleOpen}
        size="small"
        variant="outlined"
      >{t('pages.billingAndSubscriptions.createInterimInvoiceButton')}</Button>
      <Tooltip title={t('labels.help')}>
        <IconButton
          name="Interim Invoice Tips"
          size="small"
          onClick={() => showTip('createInterimInvoice')}
          sx={{ padding: '3px' }}
        >
          <InfoOutlinedIcon color="primary" /> 
        </IconButton>
      </Tooltip>
      {open && <RequestInterimInvoiceDialog open={open} onClose={handleClose} predefinedCase={predefinedCase} />}
    </Box>
  )
}
